import { API_PRECOG_URL_V1 } from "../../../config";
import { callWithRetry } from "../../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";

export const withholdingConstans = {
  UPDATE_WITHHOLDING_REASON: "UPDATE_WITHHOLDING_REASON",
  CREATE_WITHHOLDING_START: "CREATE_WITHHOLDING_START",
  CREATE_WITHHOLDING_SUCCESS: "CREATE_WITHHOLDING_SUCCESS",
  CREATE_WITHHOLDING_ERROR: "CREATE_WITHHOLDING_ERROR",

  GET_WITHHOLDINGS_LIST_START: "GET_WITHHOLDINGS_LIST_START",
  GET_WITHHOLDINGS_LIST_SUCCESS: "GET_WITHHOLDINGS_LIST_SUCCESS",
  GET_WITHHOLDINGS_LIST_ERROR: "GET_WITHHOLDINGS_LIST_ERROR",

  DELETE_WITHHOLDING_START: "DELETE_WITHHOLDING_START",
  DELETE_WITHHOLDING_SUCCESS: "DELETE_WITHHOLDING_SUCCESS",
  DELETE_WITHHOLDING_ERROR: "DELETE_WITHHOLDING_ERROR",

  UPDATE_WITHHOLDING_START: "UPDATE_WITHHOLDING_START",
  UPDATE_WITHHOLDING_SUCCESS: "UPDATE_WITHHOLDING_SUCCESS",
  UPDATE_WITHHOLDING_ERROR: "UPDATE_WITHHOLDING_ERROR",

  GET_WITHHOLDING_EDITABLE_START: "GET_WITHHOLDING_EDITABLE_START",
  GET_WITHHOLDING_EDITABLE_SUCCESS: "GET_WITHHOLDING_EDITABLE_SUCCESS",
  GET_WITHHOLDING_EDITABLE_ERROR: "GET_WITHHOLDING_EDITABLE_ERROR",

  GET_WITHHOLDING_NON_EDITABLE_START: "GET_WITHHOLDING_NON_EDITABLE_START",
  GET_WITHHOLDING_NON_EDITABLE_SUCCESS: "GET_WITHHOLDING_NON_EDITABLE_SUCCESS",
  GET_WITHHOLDING_NON_EDITABLE_ERROR: "GET_WITHHOLDING_NON_EDITABLE_ERROR",

  GET_ALL_WITHHOLDINGS_LIST_START: "GET_ALL_WITHHOLDINGS_LIST_START",
  GET_ALL_WITHHOLDINGS_LIST_SUCCESS: "GET_ALL_WITHHOLDINGS_LIST_SUCCESS",
  GET_ALL_WITHHOLDINGS_LIST_ERROR: "GET_ALL_WITHHOLDINGS_LIST_ERROR",

  GET_WITHHOLDING_DETAIL_START: "GET_WITHHOLDING_DETAIL_START",
  GET_WITHHOLDING_DETAIL_SUCCESS: "GET_WITHHOLDING_DETAIL_SUCCESS",
  GET_WITHHOLDING_DETAIL_ERROR: "GET_WITHHOLDING_DETAIL_ERROR",

  GET_WITHHOLDING_START: "GET_WITHHOLDING_START",
  GET_WITHHOLDING_SUCCESS: "GET_WITHHOLDING_SUCCESS",
  GET_WITHHOLDING_ERROR: "GET_WITHHOLDING_ERROR"
};

export function createWithholding(draftId, withholding) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {
      let request = {
        method: "POST",
        url: `${API_PRECOG_URL_V1}/precog/drafts/${draftId}/withholdings?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data: withholding
      };

      dispatch({
        type: withholdingConstans.CREATE_WITHHOLDING_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: withholdingConstans.CREATE_WITHHOLDING_SUCCESS,
              payload: result
            });
            resolve(result.data);
          } else {
            dispatch({
              type: withholdingConstans.CREATE_WITHHOLDING_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: withholdingConstans.CREATE_WITHHOLDING_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function getWithholdingsList(draftId) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/precog/drafts/${draftId}/withholdings?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: withholdingConstans.GET_WITHHOLDINGS_LIST_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: withholdingConstans.GET_WITHHOLDINGS_LIST_SUCCESS,
              payload: result
            });
            resolve(result.data);
          } else {
            dispatch({
              type: withholdingConstans.GET_WITHHOLDINGS_LIST_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: withholdingConstans.GET_WITHHOLDINGS_LIST_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function deleteWithholding(draftId, withholdingId) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {
      let request = {
        method: "DELETE",
        url: `${API_PRECOG_URL_V1}/precog/drafts/${draftId}/withholdings/${withholdingId}?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: withholdingConstans.DELETE_WITHHOLDING_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: withholdingConstans.DELETE_WITHHOLDING_SUCCESS,
              payload: result
            });
            resolve(result.data);
          } else {
            dispatch({
              type: withholdingConstans.DELETE_WITHHOLDING_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: withholdingConstans.DELETE_WITHHOLDING_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function updateWithholding(
  draftId, withholdingId, modifiedFields
) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {
      let request = {
        method: "PATCH",
        url: `${API_PRECOG_URL_V1}/precog/drafts/${draftId}/withholdings/${withholdingId}?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data: modifiedFields
      };

      dispatch({
        type: withholdingConstans.UPDATE_WITHHOLDING_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: withholdingConstans.UPDATE_WITHHOLDING_SUCCESS,
              payload: result
            });
            resolve(result.data);
          } else {
            dispatch({
              type: withholdingConstans.UPDATE_WITHHOLDING_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: withholdingConstans.UPDATE_WITHHOLDING_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function getWithholdingEditableFields(draftId, withholdingId) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    const draftId = getState().precog.invoiceDetail.data.id;
    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/precog/drafts/${draftId}/withholdings/${withholdingId}?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: withholdingConstans.GET_WITHHOLDING_EDITABLE_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: withholdingConstans.GET_WITHHOLDING_EDITABLE_SUCCESS,
              payload: result
            });
            resolve(result.data);
          } else {
            dispatch({
              type: withholdingConstans.GET_WITHHOLDING_EDITABLE_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: withholdingConstans.GET_WITHHOLDING_EDITABLE_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function getWithholdingNonEditableFields(withholding) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/withholding/with-parameters?reasonId=${withholding.reasonId}&totalNetAmount=${withholding.totalNetAmount}&cashContribution=${
          withholding.cashContribution ? withholding.cashContribution : 0
        }&notIncomeAmount=${withholding.notIncomeAmount ? withholding.notIncomeAmount : 0}&itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: withholdingConstans.GET_WITHHOLDING_NON_EDITABLE_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: withholdingConstans.GET_WITHHOLDING_NON_EDITABLE_SUCCESS,
              payload: result
            });
            resolve(result.data);
          } else {
            dispatch({
              type: withholdingConstans.GET_WITHHOLDING_NON_EDITABLE_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: withholdingConstans.GET_WITHHOLDING_NON_EDITABLE_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function getAllWithholdingsList() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/withholding?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: withholdingConstans.GET_ALL_WITHHOLDINGS_LIST_START
      });

      /* setTimeout(() => {
        const mockedResult = [
          {
            uuid: "1234",
            supplier: "Beta distribuzioni srl",
            documentNumber: "005356",
            documentDate: "2021-05-13",
            documentAmount: 100,
            totalAmount: 50,
            sentAmount: 50,
            residualAmount: 0
          },
          {
            uuid: "2345",
            supplier: "Beta distribuzioni srl",
            documentNumber: "005356",
            documentDate: "2021-05-13",
            documentAmount: 100,
            totalAmount: 50,
            sentAmount: 20,
            residualAmount: 30
          },
          {
            uuid: "3456",
            supplier: "Beta distribuzioni srl",
            documentNumber: "005356",
            documentDate: "2021-05-13",
            documentAmount: 100,
            totalAmount: 50,
            sentAmount: 40,
            residualAmount: 10
          },
          {
            uuid: "4567",
            supplier: "Beta distribuzioni srl",
            documentNumber: "005356",
            documentDate: "2021-05-13",
            documentAmount: 100,
            totalAmount: 50,
            sentAmount: 50,
            residualAmount: 0
          }
        ];
        resolve(mockedResult);
        dispatch({
          type: withholdingConstans.GET_ALL_WITHHOLDINGS_LIST_SUCCESS,
          payload: { data:  mockedResult }
        });
      }, 1500);*/

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: withholdingConstans.GET_ALL_WITHHOLDINGS_LIST_SUCCESS,
              payload: result
            });
            resolve(result.data);
          } else {
            dispatch({
              type: withholdingConstans.GET_ALL_WITHHOLDINGS_LIST_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: withholdingConstans.GET_ALL_WITHHOLDINGS_LIST_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function getWithholdingDetail(witholdingId) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;

    return new Promise((resolve, reject) => {
      // TODO sostituire fake-id con witholdingId a regime
      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/withholding/fake-id?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: withholdingConstans.GET_WITHHOLDING_DETAIL_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: withholdingConstans.GET_WITHHOLDING_DETAIL_SUCCESS,
              payload: result
            });
            resolve(result.data);
          } else {
            dispatch({
              type: withholdingConstans.GET_WITHHOLDING_DETAIL_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: withholdingConstans.GET_WITHHOLDING_DETAIL_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function getWithholding(workspaceId, withholdingId) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      /* let request = {
        method: "GET",
        url: `${API_PDC_URL_V1}/precog/allWithholdings?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };*/

      dispatch({
        type: withholdingConstans.GET_WITHHOLDING_START
      });

      setTimeout(() => {
        const mockedResult = {
          uuid: 12345,
          baseTaxableAmount: 1234,
          title: "Pippo"
        };
        resolve(mockedResult);
        dispatch({
          type: withholdingConstans.GET_WITHHOLDING_SUCCESS,
          payload: { data: mockedResult }
        });
      }, 1500);

      /* callWithRetry(
        auth, request, dispatch
      )
        .then(async result => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: withholdingConstans.GET_WITHHOLDINGS_LIST_SUCCESS,
              payload: result
            });
            resolve(result.data);
          } else {
            dispatch({
              type: withholdingConstans.GET_WITHHOLDINGS_LIST_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch(response => {
          dispatch({
            type: withholdingConstans.GET_WITHHOLDINGS_LIST_ERROR,
            error: response
          });
          reject();
        });*/
    });
  };
}
